/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Reviews_TitleInputs */

const he_hero_reviews_title = /** @type {(inputs: Hero_Reviews_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`כתבו וקראו ביקורות`)
};

const en_hero_reviews_title = /** @type {(inputs: Hero_Reviews_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write and read reviews`)
};

/**
* | output |
* | --- |
* | "Write and read reviews" |
*
* @param {Hero_Reviews_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_reviews_title = /** @type {((inputs?: Hero_Reviews_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Reviews_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_hero_reviews_title(inputs)
	return en_hero_reviews_title(inputs)
});